export enum OfferSaveMode {
  SAVE = "save",
  UPDATE = "update"
}
